import {useFetch, useRequestHeaders} from "nuxt/app";
import {useAPIBaseUrl} from "@composables/useAPIBaseUrl";
import IPageData from "@shared/interfaces/dtos/IPageData";
import { Ref } from "vue";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useSearchAPI = (filters: Ref<any>, sortBy: Ref<any>, offset: Ref<number>) => {
	const headers = useRequestHeaders(['cookie']);

	return useFetch<IPageData | null>(
		"/api/search",
		{
			server: true,
			immediate: false,
			ignoreResponseError: true,
			headers,
			method: "POST",
			body: {
				filters,
				sortBy,
				resultOffset: offset,
				portalMap: import.meta.client ? window.PortalMap : undefined
			},
			credentials: 'include',
			watch: false,
			$fetch: $fetch.create({baseURL: useAPIBaseUrl()})
		}
	);
}
